import Select from 'react-select'

const style = () => {
    return {
        control: (baseStyles: any) => ({
            ...baseStyles,
            borderRadius: '4px',
            cursor: 'text',
            minWidth: '200px',
        }),
    }
}

interface UploadConfigFileSelectProps {
    idx: number
    value: string
    optionStrings: string[]
    onSelect: (idx: number, name: string) => void
}

export const UploadConfigFileSelect = (props: UploadConfigFileSelectProps) => {
    const { idx, value, optionStrings, onSelect } = props

    const options = optionStrings.map((name: string) => ({ label: name, value: name }))

    return (
        <Select
            isSearchable={false}
            value={options.find(opt => opt.value === value)}
            onChange={opt => onSelect(idx, (opt as any).value)}
            options={options}
            styles={style()}
            placeholder={'Select config name'}
        />
    )
}

